import { isVerifyEmailErrorResponse } from '../validators/verifyEmailValidators';
import { createGenericTransformVerifyErrorResponse } from '../validation.helpers';

export const transformVerifyEmailErrorResponse =
  createGenericTransformVerifyErrorResponse(isVerifyEmailErrorResponse);
